module.exports = __webpack_public_path__ + "img/aria_chernik.d2542e26.jpg";